<template>
    <component :is="tag" style="height: 100%">
        <slot
            :contact="contact"
            :campaign="campaign"
            :proposal="proposal"
            :task="task"
            :job="job"
            :isLoading="isLoading"
            :error-message="errorMessage"
            :deliver-story-url="deliverStoryUrl"
            :deliver-insights-url="deliverInsightsUrl"
            :upload-headers="uploadHeaders"
            :is-job-delivered="isJobDelivered"
            :job-has-insights="jobHasInsights"
            :handle-story-file-change="handleStoryFileChange"
            :handle-insights-file-change="handleInsightsFileChange"
            :handle-start-connection="handleStartConnection"
            :has-uploaded-files="hasUploadedFiles"
            :uploaded-files="uploadedFiles"
            :handle-reload-proposal="handleReloadProposal"
        />
    </component>
</template>

<script>
    import ProposalsMixin from './mixins/ProposalsMixin';
    import ProposalTasksMixin from './mixins/ProposalTasksMixin';
    import ContactsMixin from './mixins/ContactsMixin';
    import CampaignsMixin from './mixins/CampaignsMixin';
    import BaseProviderMixin from './mixins/BaseProviderMixin';
    import { get } from 'lodash';
    import UploadMixin from './mixins/UploadMixin';
    import { message } from '@grininc/grin-ui';
    import NetworkConnectionSourceMixin from './mixins/NetworkConnectionSourceMixin';

    export default {
        name: 'TaskDeliveryInstagramStoryProvider',
        mixins: [
            ProposalsMixin,
            ContactsMixin,
            CampaignsMixin,
            ProposalTasksMixin,
            BaseProviderMixin,
            UploadMixin,
            NetworkConnectionSourceMixin
        ],
        computed: {
            jobId() {
                return get(this, 'job.id');
            },
            contactId() {
                return get(this, 'contact.id');
            },
            deliverStoryUrl() {
                return `/contact/${this.contactId}/jobs/${this.jobId}/deliver/story`;
            },
            deliverInsightsUrl() {
                return `/contact/${this.contactId}/jobs/${this.jobId}/deliver/story/insights`;
            }
        },
        methods: {
            handleStoryFileChange(info) {
                this.handleUploadChange(info, () => {
                    this.loadProposal(true).then(() =>
                        message.success('Nice! Your sponsorship task has been delivered')
                    );
                });
            },
            handleInsightsFileChange(info) {
                this.handleUploadChange(
                    info,
                    () => {},
                    () => {},
                    true
                );
            },
            handleReloadProposal() {
                this.loadProposal(true);
            }
        },
        created() {
            this.isLoading = true;

            this.loadContact(true)
                .then(() => {
                    return Promise.all([this.loadCampaign(), this.loadProposal()]);
                })
                .catch((error) => this.handleHttpError(error))
                .then(() => {
                    this.isLoading = false;
                });
        }
    };
</script>
